export const InputCharNumSpaceFunc = (e) => {
  // Prevent characters that are not numbers ("e", ".", "+" & "-") ✨
  let checkIfCharNum;
  if (e.key !== undefined) {
    // Check if it's a "e", ".", "+" or "-"
    checkIfCharNum =
      e.key === "." ||
      e.key === "+" ||
      e.key === "-" ||
      e.key === "*" ||
      e.key === "`" ||
      e.key === "_" ||
      e.key === "," ||
      e.key === "/" ||
      e.key === ";" ||
      e.key === "[" ||
      e.key === "\\" ||
      e.key === "]" ||
      e.key === "'" ||
      e.key === "=" ||
      e.key === "(" ||
      e.key === ")" ||
      e.key === "~" ||
      e.key === "!" ||
      e.key === "@" ||
      e.key === "#" ||
      e.key === "$" ||
      e.key === "%" ||
      e.key === "^" ||
      e.key === "&" ||
      e.key === "<" ||
      e.key === ">" ||
      e.key === "?" ||
      e.key === '"' ||
      e.key === ":" ||
      e.key === "{" ||
      e.key === "}" ||
      e.key === "|";
  } else if (e.keyCode !== undefined) {
    checkIfCharNum =
      e.keyCode === 48 ||
      e.keyCode === 49 ||
      e.keyCode === 50 ||
      e.keyCode === 51 ||
      e.keyCode === 52 ||
      e.keyCode === 53 ||
      e.keyCode === 54 ||
      e.keyCode === 55 ||
      e.keyCode === 56 ||
      e.keyCode === 57 ||
      e.keyCode === 106 ||
      e.keyCode === 107 ||
      e.keyCode === 109 ||
      e.keyCode === 110 ||
      e.keyCode === 111 ||
      e.keyCode === 186 ||
      e.keyCode === 187 ||
      e.keyCode === 188 ||
      e.keyCode === 189 ||
      e.keyCode === 190 ||
      e.keyCode === 191 ||
      e.keyCode === 192 ||
      e.keyCode === 219 ||
      e.keyCode === 220 ||
      e.keyCode === 221 ||
      e.keyCode === 222;
  }
  return checkIfCharNum && e.preventDefault();
};

export const InputCharNumFunc = (e) => {
  // Prevent characters that are not numbers ("e", ".", "+" & "-") ✨
  let checkIfNum;
  if (e.key !== undefined) {
    // Check if it's a "e", ".", "+" or "-"
    checkIfNum =
      e.key === "." ||
      e.key === "+" ||
      e.key === "-" ||
      e.key === "*" ||
      e.key === "`" ||
      e.key === "_" ||
      e.key === "," ||
      e.key === "/" ||
      e.key === ";" ||
      e.key === "[" ||
      e.key === "\\" ||
      e.key === "]" ||
      e.key === "'" ||
      e.key === "=" ||
      e.key === "(" ||
      e.key === ")" ||
      e.key === "~" ||
      e.key === "!" ||
      e.key === "@" ||
      e.key === "#" ||
      e.key === "$" ||
      e.key === "%" ||
      e.key === "^" ||
      e.key === "&" ||
      e.key === "<" ||
      e.key === ">" ||
      e.key === "?" ||
      e.key === '"' ||
      e.key === ":" ||
      e.key === "{" ||
      e.key === "}" ||
      e.key === "|" ||
      e.key === " ";
  } else if (e.keyCode !== undefined) {
    checkIfNum =
      e.keyCode === 32 ||
      e.keyCode === 48 ||
      e.keyCode === 49 ||
      e.keyCode === 50 ||
      e.keyCode === 51 ||
      e.keyCode === 52 ||
      e.keyCode === 53 ||
      e.keyCode === 54 ||
      e.keyCode === 55 ||
      e.keyCode === 56 ||
      e.keyCode === 57 ||
      e.keyCode === 106 ||
      e.keyCode === 107 ||
      e.keyCode === 109 ||
      e.keyCode === 110 ||
      e.keyCode === 111 ||
      e.keyCode === 186 ||
      e.keyCode === 187 ||
      e.keyCode === 188 ||
      e.keyCode === 189 ||
      e.keyCode === 190 ||
      e.keyCode === 191 ||
      e.keyCode === 192 ||
      e.keyCode === 219 ||
      e.keyCode === 220 ||
      e.keyCode === 221 ||
      e.keyCode === 222;
  }
  return checkIfNum && e.preventDefault();
};

export const InputCharacterCheck = (e) => {
  // Prevent characters that are not numbers ("e", ".", "+" & "-") ✨
  let checkIfChar;
  if (e.key !== undefined) {
    // Check if it's a "e", ".", "+" or "-"
    checkIfChar =
      e.key === "." ||
      e.key === "+" ||
      e.key === "-" ||
      e.key === "*" ||
      e.key === "`" ||
      e.key === "_" ||
      e.key === "," ||
      e.key === "/" ||
      e.key === ";" ||
      e.key === "[" ||
      e.key === "\\" ||
      e.key === "]" ||
      e.key === "'" ||
      e.key === "=" ||
      e.key === "(" ||
      e.key === ")" ||
      e.key === "~" ||
      e.key === "!" ||
      e.key === "@" ||
      e.key === "#" ||
      e.key === "$" ||
      e.key === "%" ||
      e.key === "^" ||
      e.key === "&" ||
      e.key === "<" ||
      e.key === ">" ||
      e.key === "?" ||
      e.key === '"' ||
      e.key === ":" ||
      e.key === "{" ||
      e.key === "}" ||
      e.key === "|" ||
      e.key === "1" ||
      e.key === "2" ||
      e.key === "3" ||
      e.key === "4" ||
      e.key === "5" ||
      e.key === "6" ||
      e.key === "7" ||
      e.key === "8" ||
      e.key === "9" ||
      e.key === "0";
    // e.key === " ";
  } else if (e.keyCode !== undefined) {
    checkIfChar =
      // e.keyCode === 32 ||
      e.keyCode === 48 ||
      e.keyCode === 49 ||
      e.keyCode === 50 ||
      e.keyCode === 51 ||
      e.keyCode === 52 ||
      e.keyCode === 53 ||
      e.keyCode === 54 ||
      e.keyCode === 55 ||
      e.keyCode === 56 ||
      e.keyCode === 57 ||
      e.keyCode === 106 ||
      e.keyCode === 107 ||
      e.keyCode === 109 ||
      e.keyCode === 110 ||
      e.keyCode === 111 ||
      e.keyCode === 186 ||
      e.keyCode === 187 ||
      e.keyCode === 188 ||
      e.keyCode === 189 ||
      e.keyCode === 190 ||
      e.keyCode === 191 ||
      e.keyCode === 192 ||
      e.keyCode === 219 ||
      e.keyCode === 220 ||
      e.keyCode === 221 ||
      e.keyCode === 222;
  }
  return checkIfChar && e.preventDefault();
};

export const DecimalValue = (e) => {
  let checkIfNum;
  if (e.key !== undefined) {
    checkIfNum = e.key === "e" || e.key === "+" || e.key === "-";
  } else if (e.keyCode !== undefined) {
    checkIfNum = e.keyCode === 69 || e.keyCode === 187 || e.keyCode === 189;
  }
  return checkIfNum && e.preventDefault();
};

export const InputNumberFuncWithE = (e) => {
  // Prevent characters that are not numbers ("e", ".", "+" & "-") ✨
  let checkIfNum;
  if (e.key !== undefined) {
    // Check if it's a "e", ".", "+" or "-"
    checkIfNum =
      // e.key === "e" ||
      e.key === "." || e.key === "+" || e.key === "-";
  } else if (e.keyCode !== undefined) {
    // Check if it's a "e" (69), "." (190), "+" (187) or "-" (189)
    checkIfNum =
      // e.keyCode === 69 ||
      e.keyCode === 190 || e.keyCode === 187 || e.keyCode === 189;
  }
  return checkIfNum && e.preventDefault();
};
